import { useState, useEffect, useCallback } from "react";
import { listLocations } from "./kpiFrequencyApi";

/**
 * Loads the company's locations, on their own and once.
 *
 * Separate from {@link useKpiFrequencyData} because the sites decide what the
 * page loads next: the selection defaults to every location, so the cadence
 * fetch cannot be the thing that discovers them without waiting on itself.
 * @returns {object} `{ sources, loading, error, reload }`.
 */
export function useLocations() {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await listLocations();
      setSources(res?.data?.data || []);
      setError(res?.isSuccess ? null : (res?.message || "Failed to load locations."));
    } catch (e) {
      console.error(e);
      setError("Failed to load locations. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { sources, loading, error, reload: load };
}
